import { AppColors } from "@/styles/colors";
import { Box, Flex, HStack, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";
import { ExternalTransferDetail } from "@/pages/requests/external-transfer/schema/external-transfer.schema";

import { RequestStatusBadge } from "../badge/RequestStatusBadge";
import { TransferRequestStatus } from "@/constants/entity-status";
import dayjs from "dayjs";
import { BeneficiaryAccountTypesLabel } from "@/constants/enums";

interface Props {
  request?: (TransferRequestDetail | ExternalTransferDetail) | null;
  showCoelsaId?: boolean;
}

export const TransferRequestMainDataCard = ({ request, showCoelsaId }: Props) => {
  return (
    <Flex width="100%" gap="12px">
      <SimpleGrid columns={{ base: 1, md: 2 }} spaceX={6} width="100%">
        {/* Detalle Origen */}
        <Box borderWidth="1px" borderRadius="md" p={4} bg="white">
          <Text fontWeight="bold" mb={2} className="amd-card-title">
            DETALLE ORIGEN
          </Text>
          <Stack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Fecha de solicitud:
              </Text>
              <Text className="account-title-label">
                {dayjs(request?.fechaSolicitud).format("DD/MM/YYYY")}
              </Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Titular Cuenta origen:
              </Text>
              <Text className="account-title-label">
                {request?.cuentaOrigen?.titular}
              </Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                N° Cuenta origen:
              </Text>
              <Text className="account-title-label">
                {request?.cuentaOrigen?.nroCuenta}
              </Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Sucursal:
              </Text>
              <Text className="account-title-label">{request?.sucursal}</Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Solicitante:
              </Text>
              <Text className="account-title-label">
                {request?.solicitante}
              </Text>
            </HStack>
          </Stack>
        </Box>

        {/* Detalle Destino */}
        <Box borderWidth="1px" borderRadius="md" p={4} bg="white">
          <Text fontWeight="bold" mb={2} className="amd-card-title">
            DETALLE DESTINO
          </Text>
          <Stack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Cuenta destino:
              </Text>
              {/* Ver como consigo este dato */}
              <Text className="account-title-label">
                {
                  BeneficiaryAccountTypesLabel[
                    request?.cuentaDestino?.type?.toLowerCase() as keyof typeof BeneficiaryAccountTypesLabel
                  ]
                }
              </Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Titular Cuenta destino:
              </Text>
              <Text className="account-title-label">
                {request?.cuentaDestino?.titular}
              </Text>
            </HStack>
            <HStack
              bgColor={AppColors.WHITE_BORDER_1}
              padding="4px"
              flexWrap={"wrap"}
            >
              <Text fontWeight="medium" className="account-title-label">
                N° Cuenta destino/CBU:
              </Text>
              <Text className="account-title-label">
                {request?.cuentaDestino.nroCuenta}
              </Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Banco:
              </Text>
              <Text className="account-title-label">
                {request?.cuentaDestino?.entidad}
              </Text>
            </HStack>
            {showCoelsaId && (
              <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
                <Text fontWeight="medium" className="account-title-label">
                  N° Coelsa:
                </Text>
                <Text className="account-title-label">
                  {(request as ExternalTransferDetail)?.coelsaId}
                </Text>
              </HStack>
            )}
            <HStack
              bgColor={showCoelsaId ? undefined : AppColors.WHITE_BORDER_1}
              padding="4px"
            >
              <Text fontWeight="medium" className="account-title-label">
                Estado:
              </Text>
              <RequestStatusBadge
                status={request?.estado as TransferRequestStatus}
              />
            </HStack>
          </Stack>
        </Box>
      </SimpleGrid>
    </Flex>
  );
};
